/**
 * Trunnion AI - Notification Settings
 */

import { useState } from 'react';
import { Card } from '@/components/ui/Card';

export function NotificationSettings() {
  const [toastsEnabled, setToastsEnabled] = useState(true);
  const [approvalAlerts, setApprovalAlerts] = useState(true);
  const [executionAlerts, setExecutionAlerts] = useState(true);
  const [autoDismiss, setAutoDismiss] = useState(5);

  return (
    <div className="space-y-6">
      <Card>
        <div className="p-6">
          <h3 className="text-lg font-semibold text-white mb-1">Toast Notifications</h3>
          <p className="text-sm text-trunnion-slate-400 mb-4">
            Configure in-app notification behavior.
          </p>
          <div className="space-y-4">
            <label className="flex items-center justify-between cursor-pointer">
              <div>
                <span className="text-sm text-white">Enable toast notifications</span>
                <p className="text-xs text-trunnion-slate-500">Show pop-up notifications for events</p>
              </div>
              <input
                type="checkbox"
                checked={toastsEnabled}
                onChange={(e) => setToastsEnabled(e.target.checked)}
                className="h-4 w-4 rounded border-trunnion-slate-600 bg-trunnion-slate-800 text-trunnion-gold-500"
              />
            </label>
            <label className="flex items-center justify-between cursor-pointer">
              <div>
                <span className="text-sm text-white">Approval request alerts</span>
                <p className="text-xs text-trunnion-slate-500">Notify when human approval is required</p>
              </div>
              <input
                type="checkbox"
                checked={approvalAlerts}
                onChange={(e) => setApprovalAlerts(e.target.checked)}
                className="h-4 w-4 rounded border-trunnion-slate-600 bg-trunnion-slate-800 text-trunnion-gold-500"
              />
            </label>
            <label className="flex items-center justify-between cursor-pointer">
              <div>
                <span className="text-sm text-white">Execution completion alerts</span>
                <p className="text-xs text-trunnion-slate-500">Notify when workflows complete or fail</p>
              </div>
              <input
                type="checkbox"
                checked={executionAlerts}
                onChange={(e) => setExecutionAlerts(e.target.checked)}
                className="h-4 w-4 rounded border-trunnion-slate-600 bg-trunnion-slate-800 text-trunnion-gold-500"
              />
            </label>
          </div>
        </div>
      </Card>

      <Card>
        <div className="p-6">
          <h3 className="text-lg font-semibold text-white mb-1">Auto-Dismiss</h3>
          <p className="text-sm text-trunnion-slate-400 mb-4">
            How long notifications stay visible before auto-dismissing.
          </p>
          <div className="flex items-center gap-4">
            <input
              type="range"
              min={2}
              max={15}
              value={autoDismiss}
              onChange={(e) => setAutoDismiss(Number(e.target.value))}
              className="flex-1 accent-trunnion-gold-500"
            />
            <span className="text-sm font-mono text-white w-16 text-right">{autoDismiss}s</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
